import { Badge, Fab } from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useAppDispatch, useAppSelector } from "../../app/redux/hooks";
import CustomDialog from "../components/custom/dialog";
import { ShopingCart } from "../view/public/shopping/cart/shopinCart";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAboutUsAsync } from "../../app/slices/footerSlice/footerSlice";
import { showSnackbar } from "../../app/slices/common/customSnackBar/customSnackbarSlice";
import { setProfilesection } from "../../app/slices/common/locationSlice/locationSlice";
export const Footer = () => {
  const { addTocart } = useAppSelector((state) => state.CartState);
  const cartCount = addTocart?.data?.length || 0;
  const [modalType, setModalType] = useState("");
  const [aboutUs, setAboutUs] = useState<any>("");
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  useEffect(() => {
    dispatch(getAboutUsAsync()).then((response: any) => {
      setAboutUs(response?.payload?.data);
    });
  }, []);
  const handleNavigateToWishList = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      dispatch(setProfilesection("Wishlist"));
      navigate("/profile");
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to see your wishlist",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };
  const handleNavigateToAccount = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      dispatch(setProfilesection("AccountDetails"));
      navigate("/profile");
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to see your account",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };
  return (
    <>
      {" "}
      <footer id="footer" className="footer background-gray md-pb-70">
        <div className="footer-wrap">
          <div className="footer-body">
            <div className="container">
              <div className="row">
                <div className="col-xl-3 col-md-6 col-12">
                  <div className="footer-infor">
                    <div className="footer-logo">
                      <a href="index.html">
                        <img src="/images/logo.svg" alt="" />
                      </a>
                    </div>
                    <ul>
                      <li>
                        <p>
                          Address: Central Junction Angamaly Ernakulam, Kerala,
                          India-683572{" "}
                        </p>
                      </li>
                      <li>
                        <p>
                          Email: <span>{aboutUs?.data?.contact_us?.email}</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          Phone:{" "}
                          <span>
                            +91 {aboutUs?.data?.contact_us?.phone_number}
                          </span>
                        </p>
                      </li>
                    </ul>
                    <a
                      style={{ marginBottom: "28px" }}
                      className="tf-btn btn-line"
                      onClick={() => {
                        navigate("/store-locations");
                      }}
                    >
                      Get direction
                      <i className="icon icon-arrow1-top-left"></i>
                    </a>
                    <ul className="tf-social-icon d-flex gap-10">
                      <li>
                        <a className="box-icon w_34 round social-facebook social-line">
                          <i className="icon fs-14 icon-fb"></i>
                        </a>
                      </li>
                      <li>
                        <a className="box-icon w_34 round social-twiter social-line">
                          <i className="icon fs-12 icon-Icon-x"></i>
                        </a>
                      </li>
                      <li>
                        <a className="box-icon w_34 round social-instagram social-line">
                          <i className="icon fs-14 icon-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a className="box-icon w_34 round social-tiktok social-line">
                          <i className="icon fs-14 icon-tiktok"></i>
                        </a>
                      </li>
                      <li>
                        <a className="box-icon w_34 round social-pinterest social-line">
                          <i className="icon fs-14 icon-pinterest-1"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6>Help</h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6>Help</h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          navigate("/privacy-policy");
                        }}
                      >
                        Privacy Policy
                      </a>
                    </li>
                    {/* <li>
                      <span className="footer-menu_item">
                        {" "}
                        Returns + Exchanges{" "}
                      </span>
                    </li> */}
                    {/* <li>
                      <span className="footer-menu_item">Shipping</span>
                    </li> */}
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          navigate("/terms-conditions");
                        }}
                      >
                        Terms &amp; Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          navigate("/faq");
                        }}
                      >
                        FAQ’s
                      </a>
                    </li>
                    {/* <li>
                      <span className="footer-menu_item">Compare</span>
                    </li> */}
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          handleNavigateToWishList();
                        }}
                      >
                        My Wishlist
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-3 col-md-6 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6>About us</h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6>About us</h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          navigate("/aboutUs");
                        }}
                      >
                        Our Story
                      </a>
                    </li>
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          navigate("/store-locations");
                        }}
                      >
                        Visit Our Store
                      </a>
                    </li>
                    {/* <li>
                      <span className="footer-menu_item">Contact Us</span>
                    </li> */}
                    <li>
                      <a
                        className="footer-menu_item"
                        onClick={() => {
                          handleNavigateToAccount();
                        }}
                      >
                        Account
                      </a>
                    </li>
                  </ul>
                </div>
                {/* <div className="col-xl-3 col-md-6 col-12">
                  <div className="footer-newsletter footer-col-block">
                    <div className="footer-heading footer-heading-desktop">
                      <h6>Subscribe</h6>
                    </div>
                    <div className="footer-heading footer-heading-moblie">
                      <h6>Subscribe</h6>
                    </div>
                    <div className="tf-collapse-content">
                      <div className="footer-menu_item">
                        Sign up to get first dibs on new arrivals, sales,
                        exclusive content, events and more!
                      </div>
                      <form
                        className="form-newsletter"
                        id="subscribe-form"
                        action="#"
                        method="post"
                        acceptCharset="utf-8"
                        data-mailchimp="true"
                      >
                        <div id="subscribe-content">
                          <fieldset className="email">
                            <input
                              type="email"
                              name="email-form"
                              id="subscribe-email"
                              placeholder="Enter your email...."
                              tabIndex={0}
                              aria-required="true"
                            />
                          </fieldset>
                          <div className="button-submit">
                            <button
                              id="subscribe-button"
                              className="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn"
                              type="button"
                            >
                              Subscribe
                              <i className="icon icon-arrow1-top-left"></i>
                            </button>
                          </div>
                        </div>
                        <div id="subscribe-msg"></div>
                      </form>
                    </div>
                  </div>
                </div> */}
                <div className="col-xl-3 col-md-6 col-12">
                  <div className="footer-newsletter footer-col-block">
                    <div className="footer-heading footer-heading-desktop">
                      <h6>App Download</h6>
                    </div>
                    <div className="footer-heading footer-heading-moblie">
                      <h6>App Download</h6>
                    </div>
                    <div className="tf-collapse-content">
                      <div className="footer-menu_item">
                        Download Navya Bakers app{" "}
                      </div>
                      <a
                        onClick={() => {
                          window.location.href =
                            aboutUs?.data?.app_url?.appstore_link;
                        }}
                      >
                        <img
                          src="/images/app-store.svg"
                          className="mt-2"
                          width="125"
                          alt=""
                        />
                      </a>
                      <a
                        onClick={() => {
                          window.location.href =
                            aboutUs?.data?.app_url?.playstore_link;
                        }}
                      >
                        <img
                          src="/images/play-store.svg"
                          className="mt-2"
                          width="125"
                          alt=""
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                    <div className="footer-menu_item">
                      © 2024 Navya Bakers. All Rights Reserved
                    </div>
                    <div className="tf-payment">
                      <img src="/images/payments/visa.png" alt="" />
                      <img src="/images/payments/img-1.png" alt="" />
                      <img src="/images/payments/img-2.png" alt="" />
                      <img src="/images/payments/img-3.png" alt="" />
                      <img src="/images/payments/img-4.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>{" "}
      <Fab
        color="primary"
        aria-label="add"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          zIndex: 1000,
        }}
        onClick={() => onOpenModal("shopingCart")}
      >
        <Badge badgeContent={cartCount} color="warning">
          <ShoppingCartOutlinedIcon />
        </Badge>
      </Fab>
      <CustomDialog
        component={<ShopingCart onClose={onCloseModal} />}
        title="Shopping Cart"
        openDialog={modalType === "shopingCart"}
        handleCloseDialog={onCloseModal}
        modalPlace="right"
      />
    </>
  );
};
